import { Upload, Button } from 'antd'
import React, { useRef } from 'react'
import { useEffect } from 'react'
import styled from 'styled-components/macro'
import { CustomeButton } from '../../../StyledComponents/Common'
import { IconImg } from '../../../StyledComponents/Header'
import AddButton from './AddButton'

function UploadFileItem(props) {
  const hiddenFileInputAdrs = useRef(null);
  let icon_img = require('../../../assets/admin/images/export.png')
  return (
    <div style={{margin: '10px 0px 5px 0px'}}>
      <>
      {props.accept?
        <input type="file" ref={hiddenFileInputAdrs} onClick={(event) => { event.target.value = null }} onChange={props.handleChange} className='mr-5 hidden' accept={props.accept} />
      :
        <input type="file" ref={hiddenFileInputAdrs} onClick={(event) => { event.target.value = null }} onChange={props.handleChange} className='mr-5 hidden' />
      }
        <ButtonSubmit htmlType="button" disabled={props.loading} onClick={()=>hiddenFileInputAdrs.current.click()} className={props.button_class? props.button_class : 'mr-5'} size='large' icon={<IconImg src={icon_img} />}>
            Upload File
        </ButtonSubmit>
      </>
      
      {props.file_name? 
        <CustomeButton onClick={()=> props.handleClick()} size='large' loading={props.loading}>Upload</CustomeButton>
      : null}
      
    </div>
    
  )
}

export default UploadFileItem


const ButtonSubmit = styled(Button)`
    width: 50%;
    background-color: #FCB614;
    color: #242424;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    padding: 6px 8px !important;
    :hover {
        border-color: #FCBD2C !important;
        color: #242424 !important;
    }
    img {
        margin-right: 10px;
    }
    margin-left: ${({ml}) => ml ? ml : '0px'};

    &.custom-file-upload:not(.selected) {
      background-color: #007bff;
      color: #fff;
    }
`